import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const concludeShopperAgentSplit = {
  name: "concludeShopperAgentSplit" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.void(),
};
